import { Chart as ChartJS, registerables, Tooltip } from 'chart.js';
import { TreemapController, TreemapElement } from "chartjs-chart-treemap";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Chart } from 'react-chartjs-2';
import { BzButton, BzToolTip } from "../../components";
import { GRID_VIEW, HEATMAP_POPOVER, WATCHLIST_GRID_INDEX } from "../../utils/global_variables";
import { LoginLoader } from "../Login";
import ZeroStates from "../ZeroStates";
import { useDispatch, useSelector } from 'react-redux';
import { updateSelectedHeatmapTile } from '../../redux/actions/watchlist';
import { getScripOrderInfo } from '../../redux/actions/orders';
import WatchListScripCard from '../Watchlist/WatchListScripCard';
ChartJS.register(...registerables, TreemapController, TreemapElement);


const HeatmapView = ({ toggleTabs, arrHeatmap, heatMapToggle, isLoader, onChangeToggleSector, handleWatchlistViewChange, selectedScripData, activeButtonToggleIndex }) => {
    /* Deepti B. [Breez-14] [23/10/2014]  
    1. changed background color for sector tile
    2. Text color and border color changed to white, changed Tile labels balck to white
    3. border width changed to 0.5
    4. Market cap in cr added on the tile and tooltip
    5. Tooltip arrow moved to bottom
    */
    const selectedHeatmapTile = useSelector(state => state?.watchList?.selectedHeatmapTile);
    const chartRef = useRef(null);
    let highLightedIndex = 0; 
    const [mouseClickX, setMouseClickX] = useState();
    const [mouseClickY, setMouseClickY] = useState();
    const [showScripCard, setShowScripCard] = useState(false);
    const [selectedTileData, setselectedTileData] = useState(null);
    const dispatch = useDispatch();

    
  const handleChartOverview = useCallback((chartData) => {
    // Deepti b. BT-107398 [18/11/2024]: Dynamically position the popover based on click event coordinates and the popover dimensions -start

    setShowScripCard(true);

    // Assign selected tile scrip data for side tray chartand side place order on click of sync watchlist -start
    const selectedTile = selectedScripData?.filter(i => i[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === chartData?.data?.id);
    setselectedTileData(selectedTile[0]);
    dispatch(updateSelectedHeatmapTile(selectedTile?.[0]));
    dispatch(getScripOrderInfo({ isBuySell: activeButtonToggleIndex, activeExchangeId: selectedTile?.[0][WATCHLIST_GRID_INDEX.EXCHANGE], scripData: selectedTile?.[0] }));
    // Assign selected tile scrip data for side tray chart and side place order on click of sync watchlist - end

    const chartWidth = chartData.chartWidth;
    const chartHeight = chartData.chartHeight;

    // fetching popover width and height
    const popoverElement = document?.getElementsByClassName('heatmap-scripdetails-popover');
    let popoverWidth = popoverElement?.[0]?.clientWidth || HEATMAP_POPOVER.POPOVER_BYDEFAULT_WIDTH;
    let popoverHeight = popoverElement?.[0]?.clientHeight || HEATMAP_POPOVER.POPOVER_BYDEFAULT_HEIGHT;

    let adjustedX = chartData.x;
    let adjustedY = chartData.y;

    // Adjust X position if popover exceeds the right edge of the chart
    if (chartData.x + popoverWidth > chartWidth) {
      adjustedX = chartWidth - popoverWidth;
    }
    // Adjust X position if popover exceeds the left edge of the chart
    if (chartData.x < 0) {
      adjustedX = 0;
    }

     // Adjust Y position if popover exceeds the bottom edge of the chart
     if (chartData.y + popoverHeight > chartHeight) {
        adjustedY = chartHeight - popoverHeight;
    }

    // Adjust Y position if popover exceeds the top edge of the chart
    if (chartData.y - popoverHeight < 0) {
      adjustedY = Math.max(0, chartData.y + (popoverHeight - chartData.y)); // push the popover inside the chart area
    }

    // set the popover position and display it
    setMouseClickX(adjustedX);
    setMouseClickY(adjustedY);

  }, [selectedScripData]);
  // Deepti b. BT-107398 [18/11/2024]: Dynamically position the popover based on click event coordinates and the popover dimensions - end
  // Deepti.B integration of common heatmap card in watchlist end

    // Deepti B. [BT-107398] fetching dataIndex for respective tile based on the ID to highlight the same -start
    const getHighlightesIndex = (id, tileData) => {
        if(id === tileData?.raw?._data?.children[0].id && tileData.type === "data") {
            if (!heatMapToggle || tileData?.raw?.gs) {
                return tileData.dataIndex;
            }
        }
    }
    // Deepti B. [BT-107398] fetching dataIndex for respective tile based on the ID to highlight the same -end

    const data = useMemo(() => {
        return {
            datasets: [{
                tree: arrHeatmap,
                key: 'size',
                groups: heatMapToggle ? ['sector', 'name'] : ['name'],
                backgroundColor: ctx => {
                    const node = ctx?.raw?._data;
                    if (!node?.name) {
                        return '#303030'
                    }
                    const firstChild = node?.children ? node?.children[0] : node;
                    return firstChild?.color ? firstChild?.color : 'rgba(75,192,192,0.5)';
                },
                borderColor: 'white',
                captions: {
                    display: true,
                    align: 'center',
                    color: 'white',
                    formatter: (ctx) => {
                        const node = ctx?.raw?._data;
                        if (!node?.name) {                                  // sector lable adjustments depends on tile size and lable length
                            if (ctx.raw.w < 100) {
                                return node.sector.substring(0, 5) + '...';
                            } else if (ctx.raw.w < 250 && node.sector.length > 15) {
                                return node.sector.substring(0, 10) + '...';
                            }
                        } else {
                            return node.sector;
                        }
                    }
                },
                borderWidth: (ctx) => {
                    let index = ctx.dataIndex;    // Tile Index
                    let highlightedId = ctx?.chart?.options?.plugins?.tileId;  // Id for the tile which is to be highlighlight
                    highLightedIndex = getHighlightesIndex(highlightedId, ctx)

                    // Highlight the tile with matching Id
                    return highLightedIndex === index ? 4 : 0.5;
                },
                labels: {
                    display: true,
                    align: 'center',
                    color: ['white', 'white'],
                    overflow: 'fit',
                    font: [{ size: 12, weight: 'bold' }, { size: 12 }],
                    formatter: (ctx) => {
                        let labelData = ctx.raw._data.children[0];
                        if (ctx.type !== 'data') {
                            return;
                        }
                            return [`${labelData.name}`, `${labelData.valuation}  (${labelData.change > .0 ? "+" : ""}${labelData.change}%)`, `${labelData.marketCap}`];
                    },
                },
            }]
        };
    }, [arrHeatmap, heatMapToggle]);

// Custom positioner, returns position of the event in canvas coordinates
    Tooltip.positioners.tooltipCustomPositioner = function(elements, eventPosition) {
            return eventPosition
    }

    const options = useMemo(() => {
        return {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                tileId: null,
                legend: {
                    display: false
                },
                tooltip: {
                    enabled: true,
                    callbacks: {
                        title: toolTipItem => {
                            let item = toolTipItem[toolTipItem.length - 1];
                            let dataset = item.raw._data.children[0];
                            if (!item?.raw?._data?.name) {
                                return dataset ? dataset.sector : '';   // sector name on the tooltip 
                            } else {
                                let name = dataset.name;
                                return name ? `${name}` : '';  // Tile Info on the tooltip
                            }
                        },
                        label: toolTipItem => {
                            if (toolTipItem.raw.g && toolTipItem.raw._data.children.length == 1 && toolTipItem.raw.gs !== undefined) {
                                let dataset = toolTipItem.raw._data.children[0];
                                if (dataset.valuation > 0) {
                                    return dataset ? [`${dataset.valuation} (${dataset.change}%)`, `${dataset.marketCap}`] : '';
                                }
                            }
                            else if (toolTipItem.raw.gs == undefined && toolTipItem.raw._data.children.length == 1 && !toolTipItem.raw._data.sector) {
                                let dataset = toolTipItem.raw._data.children[0];
                                if (dataset.valuation > 0) {
                                    return dataset ? [`${dataset.valuation}  (${dataset.change}%)`, `${dataset.marketCap}`] : '';
                                }
                            }
                            else {
                                return '';
                            }
                        },
                    },          
                    displayColors: false,
                    titleFont: { family: 'Arial', size: '14', weight: 'bold', color: '#ff0000' },
                    bodyFont: { family: 'Arial', size: '12', color: '#0000ff' },
                    borderColor: '#000',
                    borderWidth: 0.5,
                    padding: 5,
                    position: 'tooltipCustomPositioner',
                    caretPadding: 25,
                    intersect: true,
                },
            },
            onClick: (event, elements, chart) => {
                if (elements.length > 0) {
                    let objChartData = elements[elements.length - 1];
                    let datasetIndex = objChartData.datasetIndex;
                    const index = objChartData.index;
                    const nodeData = chart.data.datasets[datasetIndex].data[index];
                    if (!chart) return;
                    // Deepti b. BT-107398 [18/11/2024]: handling the click event on heatmap tile,passing the event object, chart elements and chart instants to identify the clicked tile and triggere the logic(showing pop over) 
                    const popOver = {
                        x: event.native.offsetX, //click position X
                        y: event.native.offsetY, //click position Y
                        chartWidth: chart.width,
                        chartHeight: chart.height,
                        data: nodeData._data.children[0],
                    }
                    handleChartOverview(popOver);
                }
            }
        }
    }, [arrHeatmap, heatMapToggle]);

    useEffect(() => {
// update chart pluging with the ID of the the selected Tile which is to be highlighted
        setTimeout(() => {
            let chartInstance = chartRef.current;
            if (chartInstance && selectedHeatmapTile) {
                chartInstance.options.plugins.tileId = selectedHeatmapTile?.[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN];
                chartInstance.update();
            }
        }, 600)
    }, [heatMapToggle, selectedHeatmapTile])

    // Deepti b. BT-107398 [18/11/2024]: scrip card will disappeared on change of heatmap toggle - start
    useEffect(() => {
        setShowScripCard(false);
    }, [heatMapToggle])
    // Deepti b. BT-107398 [18/11/2024]: scrip card will disappeared on change of heatmap toggle - end

    // Deepti b. BT-107398 [27/11/2024]: check if the click target is outside the chart canvas --start
    const handleOutsideClick = (event) => {
        const canvas = document.querySelector('#heatmap-canvas')
        const heatmapPopoverElement = document?.getElementsByClassName('heatmap-scripdetails-popover');
        if (!canvas || !heatmapPopoverElement || event.target !== canvas && !canvas.contains(event.target)) {
            setShowScripCard(false) // Hide the popover
        } else { }
    }

    useEffect(() => {
        // Added event listener to detect click anywhere on the document
        document.addEventListener("click", handleOutsideClick);
        return () => {
            // clean up the event listener
            document.removeEventListener("click", handleOutsideClick)
        }
    }, [])
    // Deepti b. BT-107398 [27/11/2024]: check if the click target is outside the chart canvas --end

    const colors = [
        {
            color: "#9b2120",
            label: "-3%"
        },
        {
            color: "#b8292a",
            label: "-2%"
        },
        {
            color: "#d32f2f",
            label: "-1%"
        },
        {
            color: "#b1b1b1",
            label: "0%"
        },
        {
            color: "#4caf50",
            label: "1%"
        },
        {
            color: "#417d44",
            label: "2%"
        },
        {
            color: "#345c36",
            label: "3%"
        }
    ];

    // Hari:04-10-2024: setting canvas height and width dynamically on chages on window size-start
    useEffect(() => {
        const handleResize = () => {
            const canvas = document.querySelector('#heatmap-canvas')
            if (canvas) {
                canvas.style.height = `${window.outerHeight}px`
                canvas.style.width = `${window.outerWidth}px`
            } else { }

        }
        window.addEventListener('resize', handleResize)
    }, [])
    // Hari:04-10-2024: setting canvas height and width dynamically on chages on window size-end
    return (
        <div className='hitmap-container'>
            <Container fluid className='p-0'>
                <Row className='g-0 my-2 gap-2 align-items-center justify-content-between'>
                    <Col sm='auto' className='p-2'>
                        <div className='d-flex align-items-center'>
                            <BzToolTip placement='bottom' TooltipMsg='Heatmap view is applicable only for Equity Stocks'>
                                <div className='icon-16 icon-info icon-dark'></div>
                            </BzToolTip>
                            {/* <div className='font-medium font-size3 color-text ms-1 m-t-3'>Heatmap view is applicable only for Equity Stocks</div> */}
                        </div>
                    </Col>
                    <Col sm='auto' className={`d-flex align-items-center me-2 ${toggleTabs ? "justify-content-end" : ""}`}>
                        <div className='d-flex align-items-center'>
                            <label className='toggleswitch-small'>
                                <input type="checkbox" checked={heatMapToggle} onChange={onChangeToggleSector} />
                                <span className={`toggleslider-small round`}></span>
                            </label>
                            <div className='font-regular font-size3 color-subtext ms-2'>Arrange By Sectors</div>
                        </div>
                        <div className='d-flex ms-3'>
                            {
                                colors.map((color, index) => <div className='hitmap-key-index color-text' style={{ backgroundColor: color.color }} key={index}>{color.label}</div>)
                            }
                        </div>
                    </Col>
                    {/* Deepti B. [Breez-14] [23/10/2014]  Default view button in heatmap view */}
                    <Col sm='auto' className='d-flex justify-content-end align-items-center'>
                        <BzButton className='btn btn-sm btn-primary btn-rounded' onClick={handleWatchlistViewChange.bind(this, GRID_VIEW.DEFAULT_VIEW)}>Default View</BzButton>
                    </Col>
                </Row>
                <div className='hitmap-wrapper'>
                    <LoginLoader spinner={isLoader} spinnerContent="Loading Heatmap" />          
                    {arrHeatmap?.length > 0
                        ?
                        <Chart id="heatmap-canvas" ref={chartRef} type="treemap" data={data} options={options} responsive={true} />
                        : isLoader ? null :
                        <div className='zero-state-alerts zero-state-alerts-xl'>
                            <ZeroStates subText="No data available" icon='icon-64 icon-nodata mb-3 mrgauto' />
                        </div>
                    }    
                </div>
                {
                    showScripCard && <WatchListScripCard arrRowData={selectedTileData} mouseClickX={mouseClickX} mouseClickY={mouseClickY} setShowScripCard={setShowScripCard} />
                }
            </Container>
        </div>
    );
};

export default HeatmapView;
